import { render, staticRenderFns } from "./AdminHeader.vue?vue&type=template&id=92ef2a8c&scoped=true&"
import script from "./AdminHeader.vue?vue&type=script&lang=js&"
export * from "./AdminHeader.vue?vue&type=script&lang=js&"
import style0 from "./AdminHeader.vue?vue&type=style&index=0&id=92ef2a8c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92ef2a8c",
  null
  
)

export default component.exports